import { render } from "./SignatureField.vue?vue&type=template&id=05530f00&scoped=true&ts=true"
import script from "./SignatureField.vue?vue&type=script&lang=ts"
export * from "./SignatureField.vue?vue&type=script&lang=ts"

import "./SignatureField.vue?vue&type=style&index=0&id=05530f00&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05530f00"]])

export default __exports__